module.exports = __webpack_public_path__ + "static/org_illumyn_impact-94a08018f8d8f631f1c1b7ad89d6834d.png";